import React from "react";
import SuspensionAlert from "../../components/SuspensionAlert";

export const PanelTemplate = ({children, id}) => {
    return (
        <section id={id} className="wrapper">
            <SuspensionAlert />
            {children}
        </section>
    );
}

export default PanelTemplate;
